import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('1234567890', 10);

export const uniqRequestId = (serviceId, key = 'test') => {
  if (typeof key === 'string') {
    return serviceId + parseInt(key.substr(0, 10), 36) + parseInt(nanoid(), 10);
  }
  return serviceId + key + parseInt(nanoid(), 10);
};
